<template>
    <div class="base-select">
        <v-select
            ref="inputselect"
            :value="value"
            v-bind="$attrs"
            :class="{ mobile: $vuetify.breakpoint.smAndDown }"
            outlined
            :rules="validationRules"
            dense
            :hide-details="true"
            @change="$emit('input', $event)"
            :aria-describedby="name + '-error'"
        >
            <template v-if="$slots.selection" v-slot:selection>
                <slot name="selection" />
            </template>
        </v-select>
        <div
            :id="name + '-error'"
            style="z-index: 0"
            class="error-msg with-background"
            :class="{ open: showErrorMessage }"
        >
            {{ errorMessage | uppercase }}
        </div>
    </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    value: {
      type: [String, Object, Array, Number],
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    uppercase: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    _label () {
      if (!this.label) {
        return this.label
      }
      const label = this.uppercase
        ? this.label.toUpperCase()
        : this.label
      return this.required ? label + '*' : label
    },
    validationRules () {
      const rules = [...this.rules]
      if (this.required) {
        rules.push((value) => !!value || 'Required')
      }
      return rules
    }
  },
  data () {
    return {
      showErrorMessage: false,
      errorMessage: false
    }
  },
  mounted () {
    const input = this.$refs.inputselect
    const original = input.validate
    input.validate = (force, value) => {
      const isValid = original(force, value)
      this.validate()
      return isValid
    }
  },
  methods: {
    validate () {
      this.$nextTick(() => {
        this.showErrorMessage = !this.isValid()
        this.errorMessage = this.getErrorMessage()
      })
    },
    isValid () {
      const input = this.$refs.inputselect
      if (!input) return true
      return input.valid
    },
    getErrorMessage () {
      const input = this.$refs.inputselect
      if (input && input.errorBucket && input.errorBucket.length) {
        return input.errorBucket[0]
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';

.base-select {
    position: relative; padding-bottom: 10px;
    z-index: 2;
    .mobile {
        font-size: $font-input-size !important;
    }
}

.error-msg {
    position: absolute;
    bottom: 20px;
    line-height: 12px;
    font-size: 12px;
    word-break: break-word;
    word-wrap: break-word;
    color: #bb492e;
    transition-property: all;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    opacity: 0;

    &.open {
        bottom: 0px;
        opacity: 1;
    }
}
</style>
